import { Component } from '@angular/core';
import { ShareService } from '../../services/share.service';
import { SpacesService } from '../../services/spaces.service';
import { ModalService } from '../../services/modal.service';
import { PdfExportService } from '../../services/pdf-export.service';
import { MatomoService } from '../../services/matomo.service';
import { SettingsModalComponent, SettingsData } from '../settings-modal/settings-modal.component';
import { SpaceConfigOptionsService } from '../../services/space-config-options.service';

@Component({
  selector: 'app-action-icons',
  standalone: true,
  imports: [SettingsModalComponent],
  templateUrl: './action-icons.component.html',
  styleUrl: './action-icons.component.scss'
})
export class ActionIconsComponent {
  isSettingsModalOpen = false;
  isExporting = false;
  spaceSettingsInitial: SettingsData | null = null;

  constructor(
    private readonly shareService: ShareService,
    private readonly spacesService: SpacesService,
    private readonly modalService: ModalService,
    private readonly pdfExportService: PdfExportService,
    private readonly matomoService: MatomoService,
    private readonly spaceConfigOptions: SpaceConfigOptionsService
  ) {}

  openSpaceSettings(): void {
    const space = this.spacesService.getActiveSpace();
    const countryCode = this.spaceConfigOptions.countries.find(c => c.name === space.country)?.code ?? 'DE';
    this.spaceSettingsInitial = {
      countryCode,
      languageCode: space.languageCode ?? 'en',
      currencyCode: space.currencyCode ?? 'EUR'
    };
    this.isSettingsModalOpen = true;
  }

  closeSpaceSettings(): void {
    this.isSettingsModalOpen = false;
  }

  onSpaceSettingsSaved(data: SettingsData): void {
    const countryName = this.spaceConfigOptions.countries.find(c => c.code === data.countryCode)?.name ?? 'Germany';
    const space = this.spacesService.getActiveSpace();
    this.spacesService.update(space.id, {
      country: countryName,
      languageCode: data.languageCode,
      currencyCode: data.currencyCode
    });
    this.spacesService.updateActiveSpaceLocaleSettings({
      country: countryName,
      languageCode: data.languageCode,
      currencyCode: data.currencyCode
    });
    this.isSettingsModalOpen = false;
  }

  async exportToPdf(): Promise<void> {
    if (this.isExporting) return;
    this.isExporting = true;
    try {
      const space = this.spacesService.getActiveSpace();
      await this.pdfExportService.exportSpaceAsHtml(space);
      this.matomoService.trackActionPageView(
        this.matomoService.CATEGORY.export,
        this.matomoService.ACTION.pdfExportSuccess
      );
    } catch {
      this.matomoService.trackActionPageView(
        this.matomoService.CATEGORY.export,
        this.matomoService.ACTION.pdfExportFailed
      );
    } finally {
      this.isExporting = false;
    }
  }

  shareSpace(): void {
    const space = this.spacesService.getActiveSpace();
    this.shareService.shareSpace(space);
  }

  deleteSpace(): void {
    const space = this.spacesService.getActiveSpace();
    this.modalService.openDeleteSpaceModal(space.id);
  }
}
